require("../../../libs/backbone/backbone.ajaxq.adapter.ts");
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../../templates/supervision/supervision.template.htm');
var Table = require('text-loader!../../templates/supervision/supervision_table.template.htm');
require('dhtmlxMessage');
var Model = require('../../models/patients.model.ts');
// var QueuesOptions = require("views/queues_options.view.ts");
var QueuesOptions = require("../kiosks_queues_options.view.ts");
var i18n = require('l10n');
var PatientsCollection = require('../../models/patients.collection.ts');
var Collection = require('../../models/tickets.paginated.collection.ts');
var SupervisionRowView = require("./supervisionRow.view.ts");
var PaymentPopupTemplate = require('text-loader!../../templates/tickets/hasOnlyPaymentPopup.template.html');

var SockJS = require('sockjs-client');
var Stomp = require('stompjs');

var TheView = GenericView.extend({
    el: "#container",
    tagName: 'div',
	template: Handlebars.compile(Template),
    tableTemplate: Handlebars.compile(Table),
	PaymentPopupTemplate: Handlebars.compile(PaymentPopupTemplate),
	superInitialize: GenericView.prototype.initialize,
	model : null,
	id: null,
    editable: null,
    fields: null,
    userData: null,
    privilegeLevel: null,
    back: false,
    collection: null,
    tableLoaded: false,
    selectedQueueIds: null,
	queueTicketStompSubscriptions: null,
    queuesData: null,
	initialize: function (options) {
	    var self = this;
	    this.id = options ? options.id : null;
        this.userData = options.data;
        this.privilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);
        // this.patientsCollection = new PatientsCollection();
        
        // this.collection = new Collection();
		// this.collection.state.pageSize = 999;
		// this.collection.on( 'sync', this.successData, this );
		// this.collection.on( 'error', this.errorData, this );

		// this.collection.url = '/rest/api/admin/OrgsVenuesQueues';
		// this.collection.getFirstPage();
        this.setListener(); // stomp listener

        if(this.id) {
            this.editable = true;
            this.model = new Model({ id : this.id });
            this.model.fetch({
                success: function(response)
                {
                    self.render();
                },
                error: function(response, xhr, status)
                {

                }
            });
        } else {
            this.editable = false;
            this.model = new Model();
            this.render();
        }

        this.fields =
        {
            firstName: [this.isEmpty],
            lastName: [this.isEmpty],
            phoneNumber: [this.isEmpty]
        }

        $(window).on('beforeunload', function () {
            self.unsubscribeStomp();
            return '';
        });

        Backbone.history.on('route', function () {
            self.unsubscribeStomp();
        });
	},
	superRender: GenericView.prototype.render,
	render: function () {  
        this.superRender();
		var self = this;

		var data = $.extend(this.model.toJSON(), { editable: this.editable, queueType: 'queuesExaminations' });

        this.$el.html(this.template(data));

        this.queuesOptions = new QueuesOptions(data);

	},
	events: {
        "click #submitBack": "clickOnSubmitBack",
        "click #reset": "clickOnReset",
        "click #changeQueuesBtn": "changeQueues",
        "click .pending-btn": "actionNextTicket"
	},
    setListener: function()
    {
        var self = this;

        this.wsocket = new SockJS('rest/live');
        this.client = Stomp.over(this.wsocket);

        var headers = {
            //origin: 'https://www.qedis-metro.com', toDo: enable it
        };

        this.client.connect(headers,
            function(frame) {
                //self.subscribeToStomp(self);
            },
            function(onCloseMessage) {
                if(onCloseMessage.indexOf('Whoops! Lost connection to') > -1) {
                    //
                    console.log("connection closed");
                }
            }
        );
    },
    onCancel: function()
    {
       this.goBack();
    },
	clickOnReset: function(e)
    {
        // $("#firstName").find("input").val("");
        // $("#lastName").find("input").val("");
        // $("#phoneNumber").find("input").val("");
        // this.queuesOptions.clearView();
    },
    // addNewPayment: function() {

    //     var selectedQueues = this.getSelectedQueues() !== undefined ? this.getSelectedQueues() : [];

    //     var data = {
    //         firstName: $("#firstName").find("input").val().trim(),
    //         lastName: $("#lastName").find("input").val().trim(),
    //         phoneNumber: $("#phoneNumber").find("input").val().trim(),
    //         queueIds: selectedQueues
    //     };

    //     this.patientsCollection.add(data);

    //     console.log('Item added to collection:', data);

    //     this.clickOnReset();
    // },
	clickOnSubmitBack: function(e)
    {
       this.back = true;
        this.clickOnSubmit(e);

    },
	clickOnSubmit: function(e)
    {
        var self = this;

        self.selectedQueueIds = this.getSelectedQueues() !== undefined ? this.getSelectedQueues() : [];

        var selectedQueuesNames = this.getSelectedQueuesNames() !== undefined ? this.getSelectedQueuesNames() : [];

        var has_error;

        // const $customersContainer = $("#customersContainer");
        
        // $customersContainer.empty();

        // var tr = $("<tr/>");
        // tr.css("display", "block");
        // tr.html(self.progressTemplate());
        // $customersContainer.append(tr);

        if(self.selectedQueueIds.length === 0) {
            has_error = true;
            this.$el.find('#kQueuesOptions .chosen-choices').addClass("has-error");
            self.setError($("#kQueuesOptions"), i18n.t("account.empty_field"));
        }

        if(!has_error)
        {
            
            self.loadCustomersData(selectedQueuesNames)

            self.subscribeToStomp(this);
        }
        else {
            this.hideActionProgressBar();
            $.notify(
                i18n.t("account.check_errors"),
                { position:"top center", className: "error" }
            );
        }

    },
    validateIt: function(event)
    {
        if(event.which > 36 && event.which < 41)
            return;

        var element = $(event.currentTarget).parent();
        var field = {};
        field[element.prop("id")] = this.fields[element.prop("id")]

        var has_error = this.validateFields( field );
    },
    validateSelectField: function(event)
    {
        var self = this;
        var selectedQueues = this.getSelectedQueues() !== undefined ? this.getSelectedQueues() : [];

        if(selectedQueues.length === 0) {
            this.$el.find('#kQueuesOptions .chosen-choices').addClass("has-error");
            self.setError($("#kQueuesOptions"), i18n.t("account.empty_field"));
        } else {
            this.$el.find('#kQueuesOptions .chosen-choices').removeClass("has-error");
            self.clearError($("#kQueuesOptions"));
        }
    },
    getSelectedQueues: function() {
        var queuesIdsArray = [];
        var queuesName = [];

        this.$el.find('#kQueuesOptions .chosen-choices .search-choice').each(function() {
            var option = $(this).find('span').text();
            var match = option.match(/^\d+(?= -)/);

            if (match) {
                var queueId = parseInt(match[0], 10);
                queuesIdsArray.push(queueId);
            }
        });

        return queuesIdsArray.sort((a, b) => a - b);
    },
    getSelectedQueuesNames: function() {
        var queuesName = [];
        var temp = [];
        this.$el.find('#kQueuesOptions .chosen-choices .search-choice').each(function() {
            var option = $(this).find('span').text();
            var parts = option.split(' - ');

            if (parts.length === 2) {
                temp.push({
                    order: parseInt(parts[0], 10),
                    name: parts[1]
                });
            }
        });

        // sort by the number before the dash
        temp.sort(function (a, b) {
            return a.order - b.order;
        });

        // push sorted names
        temp.forEach(function (item) {
            queuesName.push(item.name);
        });

        return queuesName;
    },
    addPaymentResponse: function(successOrError, response) {
        var self = this;

        if(successOrError === 'success') {
            //Hide the generic progress bar
            self.hideActionProgressBar();
            if (self.editable) {
                $.notify(i18n.t("patients.patient_updated"), { position: "top center", className: "success" });
                
                if (self.back)
                    self.goBack();
                    self.back = false;
                }
            else {
                $.notify(i18n.t("patients.patient_added"), { position: "top center", className: "success" });
                self.goBack();
            }
        } else if(successOrError === 'error') {
            if (response.status == 409) {
                self.hideActionProgressBar();
                $.notify(i18n.t("patients.error_patient_exists"), { position: "top center", className: "error" });
            }
        }
    },
    loadCustomersTable: function(response, selectedQueuesNames) {
        var self = this;

        $('#supervisionQueuesContainer').empty();

        $('#table-container').html(self.tableTemplate(
            { 
                "customers" : response
            }));

        selectedQueuesNames.forEach(queue => {
            $('#supervisionTableHeader tr').append('<th class="col">'+ queue +'</th>')
        });

        self.tableLoaded = true;
    },
    loadCustomersData: function(selectedQueuesNames) {
        var self = this;

        var queueIdsString = self.selectedQueueIds.toString();

        $.ajaxDefaultQ({
            url: '/rest/api/customers/with-tickets/table?queueIds=' + queueIdsString,
            type: 'GET',
        }).done(function(response, status, xhr){

            if(self.tableLoaded === false) {
                self.loadCustomersTable(response, selectedQueuesNames);
            }

            self.queuesData = response.sort(function (a, b) {

                function isEndCustomer(customer) {
                    var queues = customer.queues || [];

                    for (var i = 0; i < queues.length; i++) {
                    var status = queues[i].status;

                    if (status === 'Pending' || status === 'Servicing' || queues[i].canIssueTicket === true) {
                        return false;
                    }
                    }

                    return true;
                }

                return isEndCustomer(a) - isEndCustomer(b);
            });
            
            self.loadCustomers(response)

        })
        .fail(function(response) {
            console.log('response', response);
        //    element.parent().find("i").hide();
        //    console.info(response);
        });
    },
    loadCustomers: function(data) {
        var self = this;

        const $customersContainer = $("#customersContainer");
        $customersContainer.empty();

        var tr = $("<tr/>");
        tr.css("display", "block");
        tr.html(self.progressTemplate());
        $customersContainer.append(tr);
        
        self.renderSupervision($customersContainer, data, null)
    },
    renderSupervision: function($customersContainer, data, stompData) {
	    var self = this;

	    $customersContainer.empty();

        $.each(data, function(i, item) {

            var params = {
                "wsocket": self.wsocket,
                "client": self.client,
                "model": item
            };

            var rowView = new SupervisionRowView( params );
            $customersContainer.append( rowView.render().el );

            // var $popup = $("#ticketsPaymentsAppointmentsPopup").find(".tpaPopup");
            // var id = parseInt( $($popup[0]).data("id") );
            // var isPayment = $($popup[0]).data("type") == "payment";
            // var isTicket = $($popup[0]).data("type") == "ticket";

            // var isSameId = isTicket
            //     ? id == item.id
            //     : isPayment
            //         ? id == item.paymentId
            //         : false;

            // // if it has, an opened popup, reload it
            // if( !isNaN(id) && isSameId && $popup.parent().css("display") == "block" ) {
            //     // check if this user, has done the action that closes automatically the popup. If so, then do NOT close the popup, it will be closed automatically.
            //     var hasThisUserDoneThisAction = stompData && stompData.userId == self.userData.id;

            //     if(!hasThisUserDoneThisAction) {
            //         rowView.closePopup();
            //         $(rowView.$el.find("td")[0]).trigger("click");
            //     }
            // }
        });
	},
    changeQueues: function() {
        this.render();
        this.tableLoaded = false;
        this.selectedQueueIds = null;
        this.unsubscribeStomp();
    },
    subscribeToStomp: function(self) {
	    if(self.queueTicketStompSubscription == null) {
            self.queueTicketStompSubscription = self.client.subscribe('/live/admin/tickets/queue/', function (message){
                // console.log('MESSAGE', message);
                // var responseObject = JSON.parse( message.body );

                // if(responseObject.queueId) {
                    // var elem = $("#queue-" + responseObject.queueId);
                    self.loadCustomersData(null);
                // }
            });
	    }
    },
    unsubscribeStomp: function() {
        if(this.queueTicketStompSubscription) {
            this.queueTicketStompSubscription.unsubscribe();
            this.queueTicketStompSubscription = null;
        }
    },
    actionNextTicket: function(e) {
	    // var self = this;

        // disable "mistaken" click on NEXT button, while the popup is visible
	    // if($("#preparationPopup").hasClass('shown-preparation-popup'))
	    //     return;

	    // if(this.nextButtonClicked == true)
	    //     return;

	    // this.nextButtonClicked = true;

	    var self = this;

        var ticketId = $(e.currentTarget).data("ticket-id");
        var queueId = $(e.currentTarget).data("queue-id");
        var currentRow = self.queuesData.find(d => d.queues.some(q => q.ticketId === ticketId))
        
		this.showActionProgressBar();
        
        //GET Counters
        
        $.ajaxDefaultQ({
            url: '/rest/api/admin/counters/' + queueId,
            type: 'GET',
        }).done(function(response, status, xhr){
            if(response.length > 1) {
                self.showPopup(e, response, currentRow);
            } else if(response.length === 1) {
                var counterId = response[0].id;
                var servicingTicketExists = self.queuesData.flatMap(queue => queue.queues).some(q => q.queueId === queueId && q.status === "Servicing" && q.servicedCounterId === counterId);
                if(servicingTicketExists) {
                    var currentServicingTicket = self.queuesData.flatMap(queue => queue.queues).find(q => q.queueId === queueId && q.status === "Servicing" && q.servicedCounterId === counterId).ticketId;

                    var hasTicketBeenServed = $.when(self.servicedTicket(currentServicingTicket)).then(function(resp) {
                        console.log('resp', resp);
                        return resp == true || resp.data.status == "Serviced" || resp.data.status == "Pre_Serviced";
                    });
                    
                    if(!hasTicketBeenServed)
                        return;
                }
                self.nextTicket(queueId, ticketId, counterId);
            } else {
                $(e.currentTarget).notify(i18n.t("counter.allCountersClosed"),
                {
                    position: "left center",
                    className: "info",
                    autoHide: true
                });
                self.hideActionProgressBar();
            }
        })
        .fail(function(response) {
            console.log('response', response);
            $(e.currentTarget).notify(i18n.t("server.errorOccurred"),
                {
                    position: "top center",
                    className: "error",
                    autoHide: true
                });
                self.hideActionProgressBar();
        });

        // this.showPopup(e);
        // this.nextTicket(queueId, ticketId);
	},
    nextTicket: function(queueId, selectedTicket, counterId) {
		var self = this;
		// if (this.specificNext == true) {
            var data = {
                "queueId": +queueId,
                "ticketId": +selectedTicket
            }
		// } else {
		//     var data = "queueId="+this.queueData.id;
		// }

		var url = "rest/api/admin/tickets/next/specific?queueId="+ queueId +"&ticketId="+ selectedTicket +"&counterId=" + counterId;

		this.doCall(url, "POST",
			function(response, status, xhr){
				self.hideActionProgressBar();

                if(response && response.data && response.data && response.data.error) {
                    //$("#nextBtn").notify(response.data.error, { position:"top center", className: "error" });
                    console.error(response.data.error);
                }

                if(response && response.data == "NextBlocked") {
                    $("#nextBtn").notify(i18n.t('counter.blockedByAdmin'),
                    {
                        position:"top center",
                        className: "info",
                        autoHideDelay: 10000
                    });
                }

				// if(response && response.data.customer && response.data.customer.deviceOs == "NoDevice")
				// 	self.currentPhone = response.data.customer.deviceId;
				// else
				    self.loadCustomersData(null);
			},
			function(status){
				self.hideActionProgressBar();

				self.loadCustomersData(null);
			},
			data
		);
	},
	servicedTicket: function(ticketId) {
		if(ticketId == null) {
		    this.hideActionProgressBar();
		    return true;
		}

		var self = this;
		return this.doCall("rest/api/agent/tickets/serviced?id="+ticketId+"&callback=nextTicket", "POST",
			function(response, status, xhr){
				self.hideActionProgressBar();

                return response.data.status;
			},
			function(status, self){
			    self.hideActionProgressBar();

				$.notify(i18n.t('counter.noPendingTickets'), { position:"top center", className: "info" });

				return true;
			}
		);
	},
    doCall: function(url, type, successCallback, errorCallback) {
		// if(!data)
		// 	data = "";

		var self = this;
		return $.ajaxDefaultQ({
            url: url,
            type: type
        }).done(function(response, status, xhr){
			successCallback(response, status, xhr, self);
        })
        .fail(function(response) {
        	errorCallback(response, self);
        });
	},
    showPopup: function(e, counters, currentRow) {
        var isTicket = !isNaN(this.model.number);

        var $popupContainer = $("#ticketsPaymentsAppointmentsPopup");
        $popupContainer.empty();

        // if(isTicket) {
            // $popupContainer.html( this.ticketPopupTemplate(this.model)  );
        // }
        // else {
        
        var data = $.extend(currentRow, { counters: counters });
        $popupContainer.html( this.PaymentPopupTemplate(data)  );
        // }

        var $popup = $popupContainer.find(".tpaPopup");

        $popupContainer.show();

        this.bindPopupEvents(e, currentRow);
    },
    bindPopupEvents: function(e, currentRow) {
        var self = this;

        // this.lastClickedButton = $(e.currentTarget);

        // if(isTicket) {
        //     $("#submitTicketChange").off("click").on("click", function() {
        //         var $btn = $(this);
                
        //         $btn.prop('disabled', true); // disable button, to avoid multiple clicks

        //         var ticketId = self.model.id;
        //         var ticketPriority = parseInt($("#ticketsPaymentsAppointmentsPopup").find(".tpaPopup").find('.ticketPriority').val());
        //         var queueId = self.model.queueId;

        //         $.ajaxDefaultQ({
        //             url: "rest/api/admin/ticket/priority?ticketId=" + ticketId + "&status="+ ticketPriority + "&queueId=" + queueId,
        //             type: "POST",
        //             contentType: "application/json",
        //             data: {}
        //         }).done(function(response, status, xhr){

        //             if(response && response.error == null) {

        //                 var text = "";
        //                 var className = "";

        //                 if(response.data == true || response.data && response.data.value == true) {
        //                     text = i18n.t("tickets.priorityChangedSuccessfully");
        //                     className = "success";
        //                 }
        //                 else if(response.data == false || response.data && response.data.value == false) {
        //                     text = i18n.t("server.errorOccurred");
        //                     className = "error";

        //                     // revert selection
        //                     $btn.val($btn.data("last-value"));
        //                 }
        //                 else {
        //                     text = i18n.t("server.errorOccurred");
        //                     className = "error";

        //                     // revert selection
        //                     $btn.val($btn.data("last-value"));
        //                 }

        //                 $btn.notify(text,
        //                 {
        //                     position: "top center",
        //                     className: className,
        //                     autoHide: true
        //                 });

        //             }
        //             else {
        //                 $btn.notify(i18n.t("server.errorOccurred"),
        //                 {
        //                     position:"top center",
        //                     className: "error",
        //                     autoHide: true
        //                 });

        //                 // revert selection
        //                 $btn.val($btn.data("last-value"));
        //             }

        //             setTimeout(function() {
        //                 self.closePopup();
        //                 $btn.prop('disabled', false);
        //             }, 2000);
        //         })
        //         .fail(function(response) {
        //             $btn.notify(i18n.t("server.errorOccurred"),
        //             {
        //                 position: "top center",
        //                 className: "error",
        //                 autoHide: true
        //             });

        //             setTimeout(function() {
        //                 self.closePopup();
        //                 $btn.prop('disabled', false);
        //             }, 2000);
        //         });
        //     });

        //     $("#submitTicketCancel").off("click").on("click", function() {
        //         if(!confirm(i18n.t('tickets.confirmCancellation')))
        //             return;

        //         var $btn = $(this);

        //         $btn.prop('disabled', true); // disable button, to avoid multiple clicks

        //         var ticketId = self.model.id;
        //         var queueId = self.model.queueId;

        //         $.ajaxDefaultQ({
        //             url: "rest/api/admin/ticket/cancel?ticketId=" + ticketId + "&queueId=" + queueId,
        //             type: "POST",
        //             contentType: "application/json",
        //             data: {}
        //         }).done(function(response, status, xhr){

        //             if(response && response.error == null) {

        //                 var text = "";
        //                 var className = "";

        //                 if(response.data == true || response.data && response.data.value == true) {
        //                     text = i18n.t("tickets.ticketCancelledSuccessfully");
        //                     className = "success";
        //                 }
        //                 else if(response.data == false || response.data && response.data.value == false) {
        //                     text = i18n.t("server.errorOccurred");
        //                     className = "error";

        //                     // revert selection
        //                     $btn.val($btn.data("last-value"));
        //                 }
        //                 else {
        //                     text = i18n.t("server.errorOccurred");
        //                     className = "error";

        //                     // revert selection
        //                     $btn.val($btn.data("last-value"));
        //                 }

        //                 $btn.notify(text,
        //                 {
        //                     position: "top center",
        //                     className: className,
        //                     autoHide: true
        //                 });

        //             }
        //             else {
        //                 $btn.notify(i18n.t("server.errorOccurred"),
        //                 {
        //                     position:"top center",
        //                     className: "error",
        //                     autoHide: true
        //                 });

        //                 // revert selection
        //                 $btn.val($btn.data("last-value"));
        //             }

        //             setTimeout(function() {
        //                 self.closePopup();
        //                 $btn.prop('disabled', false);
        //             }, 2000);
        //         })
        //         .fail(function(response) {
        //             $btn.notify(i18n.t("server.errorOccurred"),
        //             {
        //                 position: "top center",
        //                 className: "error",
        //                 autoHide: true
        //             });

        //             setTimeout(function() {
        //                 self.closePopup();
        //                 $btn.prop('disabled', false);
        //             }, 2000);
        //         });
        //     });
        // }
        // else { // isPayment
            $("#submitTicketIssue").off("click").on("click", function() {
                var $btn = $(this);

                $btn.prop('disabled', true); // disable button, to avoid multiple clicks

                var queueId = $(e.currentTarget).data("queue-id");
                // var paymentId = currentRow.queues.find(queue => queue.queueId === queueId).paymentId;
                var ticketId = currentRow.queues.find(queue => queue.queueId === queueId).ticketId;
                var counterId = parseInt($("#ticketsPaymentsAppointmentsPopup").find(".tpaPopup").find('.ticketPriority').val());
        
                var servicingTicketExists = self.queuesData.flatMap(queue => queue.queues).some(q => q.queueId === queueId && q.status === "Servicing" && q.servicedCounterId === counterId);

                if(servicingTicketExists) {
                    var currentServicingTicket = self.queuesData.flatMap(queue => queue.queues).find(q => q.queueId === queueId && q.status === "Servicing" && q.servicedCounterId === counterId).ticketId;

                    var hasTicketBeenServed = $.when(self.servicedTicket(currentServicingTicket)).then(function(resp) {
                        console.log('resp', resp);
                        return resp == true || resp.data.status == "Serviced" || resp.data.status == "Pre_Serviced";
                    });
                    
                    if(!hasTicketBeenServed)
                        return;
                }
                self.nextTicket(queueId, ticketId, counterId);
                self.closePopup();
            });
        // }

        // both cases
        $("#closeTicketPopup").off("click").on("click", function() {
            var $popup = $("#ticketsPaymentsAppointmentsPopup").find(".tpaPopup");
            $popup.parent().hide();
            $popup.empty();
            self.hideActionProgressBar();

        });
    },
    closePopup: function() {
        $("#closeTicketPopup").trigger("click");
    }
});

module.exports = TheView;